export const menuItems = [
    {
        menuTitle: "Auto zoeken",
        mobileOnly: false,
        dropdownItems: [
            { title: "Alle auto's", link: "/aanbod" },
            {
                title: "Hybride auto",
                link: "/aanbod/brandstofsoort/hybride-benzine"
            },
            {
                title: "Stationwagen",
                link: "/aanbod/carrosserievorm/stationwagen"
            },
            { title: "SUV", link: "/aanbod/carrosserievorm/suv" }
        ]
    },
    {
        menuTitle: "Autogids",
        mobileOnly: false,
        dropdownItems: [{ title: "Auto overzicht", link: "/auto" }]
    },
    {
        menuTitle: "Hulp bij kopen",
        mobileOnly: false,
        dropdownItems: [{ title: "Blog", link: "/blog" }]
    },
    {
        menuTitle: "Mijn Autotrack",
        mobileOnly: true,
        dropdownItems: [
            { title: "Accountgegevens", link: "/mijn-autotrack" },
            { title: "Auto verkopen", link: "/mijn-autotrack/verkoop" },
            { title: "Favorieten", link: "/mijn-autotrack/favorieten" },
            { title: "Zoekopdrachten", link: "/mijn-autotrack/zoekservice" }
        ]
    }
] as const;
